import api from '../index';
import QueryContext from '../QueryContext';

// TODO: Remove this file

const campaignFetchers = {
  campaign: (context: QueryContext) =>
    api.get(`/campaigns/${context.meta?.id}`, {}),
};
export default campaignFetchers;
